import React, { useState, useEffect } from "react";
import { Checkbox } from 'react-materialize';

export default function GroupItems({data, handleEvents}) {
    return <div key={"group-items-"+data.inx} className="row">
        {data.groups.map((item, i) => {
            return <div key={"group-item-"+data.inx+"-"+i} className="col s4 group-item">
                <Checkbox
                    checked={(data.userGroups.indexOf(item.group_id.toString()) >= 0) ? true : false}
                    filledIn
                    id={"group-item-"+data.inx+"-"+i}
                    name="user_group"
                    label={item.name}
                    value={item.group_id.toString()}
                    onChange={handleEvents.OnChange}
                />
            </div>
        })}
    </div>
}